export default {
  signIn: 'Masuk',
  signOut: 'Keluar',
  points: 'poin',
  hyattSignInButton: 'Masuk ke World of Hyatt',
};
